import React from 'react';
import type { ResumeData } from '../types';
import { formatDate } from '../utils';

export function MinimalTemplate({ data }: { data: ResumeData }) {
  return (
    <div className="max-w-4xl mx-auto bg-white p-8">
      {/* Header */}
      <header className="mb-8">
        <h1 className="text-3xl font-light text-gray-900 mb-2">{data.personalInfo.fullName}</h1>
        <div className="text-sm text-gray-600 flex flex-wrap gap-4">
          <span>{data.personalInfo.email}</span>
          <span>{data.personalInfo.phone}</span>
          <span>{data.personalInfo.location}</span>
          {data.personalInfo.website && <span>{data.personalInfo.website}</span>}
        </div>
      </header>

      {/* Experience */}
      <section className="mb-8">
        <h2 className="text-lg font-light uppercase tracking-wider mb-4 text-gray-800 border-b pb-2">Experience</h2>
        {data.experiences.map((exp) => (
          <div key={exp.id} className="mb-6">
            <div className="flex justify-between items-baseline mb-1">
              <h3 className="text-base font-medium">{exp.position}</h3>
              <span className="text-sm text-gray-600">
                {formatDate(exp.startDate)} - {exp.isCurrentJob ? 'Present' : formatDate(exp.endDate)}
              </span>
            </div>
            <p className="text-sm text-gray-600 mb-2">{exp.company}</p>
            <p className="text-sm text-gray-700">{exp.description}</p>
          </div>
        ))}
      </section>

      {/* Education */}
      <section className="mb-8">
        <h2 className="text-lg font-light uppercase tracking-wider mb-4 text-gray-800 border-b pb-2">Education</h2>
        {data.education.map((edu) => (
          <div key={edu.id} className="mb-4">
            <div className="flex justify-between items-baseline mb-1">
              <h3 className="text-base font-medium">{edu.degree}</h3>
              <span className="text-sm text-gray-600">
                {formatDate(edu.startDate)} - {edu.isPursuing ? 'Present' : formatDate(edu.endDate)}
              </span>
            </div>
            <p className="text-sm text-gray-600">{edu.institution}</p>
          </div>
        ))}
      </section>

      {/* Skills */}
      <section>
        <h2 className="text-lg font-light uppercase tracking-wider mb-4 text-gray-800 border-b pb-2">Skills</h2>
        <div className="grid grid-cols-1 gap-4 text-sm">
          <div>
            <h3 className="font-medium mb-2">Technical Skills</h3>
            <p className="text-gray-700">{data.skills.technical}</p>
          </div>
          <div>
            <h3 className="font-medium mb-2">Soft Skills</h3>
            <p className="text-gray-700">{data.skills.soft}</p>
          </div>
        </div>
      </section>
    </div>
  );
}